<script>
import VcHeader from './Header'
import VcAside from './Aside'
import VcMain from './Main'

export default {
  name: 'VcLayout',

  components: {
    VcMain,
    VcAside,
    VcHeader,
  },

  data: () => ({
  }),
}
</script>

<template>
  <ElContainer class="page-container" direction="vertical">
    <VcHeader />
    <ElContainer class="overflow-hidden">
      <VcAside />
      <VcMain class="scrollbar" />
    </ElContainer>
  </ElContainer>
</template>

<style lang="scss" scoped>
.page-container {
  overflow: hidden;
  width: 100vw;
  height: 100vh;
}
</style>
